export default class LocaleService {
  public constructor() {}

  public get locale(): string {
    //return i18n.locale;
    return 'de'
  }

  public set locale(locale: string) {
    // unused currently
  }
}
